/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/carpools/home"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center">Sélectionner des communautés</h1>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" forceOverscroll="false">
      <div class="mc-white-container">

        <ion-item class="ion-no-padding">
          <ion-input
            ref="inputSearch"
            type="text"
            name="search"
            v-model="search"
            @input="search = $event.target.value"
            placeholder="Recherche"
          ></ion-input>
        </ion-item>

        <div class="text-center" style="margin-top: 20px" v-if="loading">
          <ion-icon size="large" color="primary" class="rotating"  name="sync"></ion-icon>
        </div>


        <ion-item v-for="community in filteredCommunities()" v-on:click="switchCommunity(community.id)">
          <ion-avatar slot="start">
            <img style="object-fit: contain" :src="!!community.images[0] ? community.images[0].versions.square_250 : '/assets/communities.png'" alt="" />
          </ion-avatar>
          <ion-label>{{ community.name }}</ion-label>
          <ion-checkbox slot="end" v-bind:checked="user.communityId.includes(community.id)"></ion-checkbox>
        </ion-item>


      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">

.flex-card {
  display: flex;
  align-items: center;

  & .iconSearch {
    width: 50px !important;
    height: 50px !important;
    margin-left: 0px !important;
    border-radius: 25px;
    color: white;
    font-size: 33px;
    display: flex;
    justify-content: center;
    min-width: 50px !important;
  }
}
</style>

<script>

export default {
  name: "select-community",
  mixins: [],
  components: {},
  created() {
    if (!this.user.communityId) {
      this.user.communityId = [];
      this.user = this.user;
    }

    this.$store.dispatch('getAllCommunities', {query: '', number: 1000}).then(res => {
      this.communities = res.data['hydra:member']
      this.loading = false;
    }).catch(err => {
      this.loading = false;
    })
  },
  computed: {
    user: {
      get() {
        return this.$store.state.registerStore.userToRegister
      },
      set() {
        this.$store.commit('register_update', this.user);
      }
    },
  },
  data() {
    return {
      communities: [],
      selectedCommunities: [],
      search: '',
      loading: true
    };
  },
  methods: {
    filteredCommunities() {
      return this.communities.filter(item => item.name.toLowerCase().includes(this.search.toLowerCase()))
    },
    switchCommunity(communityId) {
      const f = this.user.communityId.findIndex(item => item == communityId)
      if (f >= 0) {
        this.user.communityId.splice(f, 1);
      } else {
        this.user.communityId.push(communityId)
      }
      this.user = this.user;
    }
  }
};
</script>
